import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import { Route, Routes } from "react-router-dom"; //IndexRoute has been removed (never used)
import { RESOLUTIONS } from "services/config";
import CookieConsent from "react-cookie-consent";
/** v3 imports */
import { BloxButton } from "styled_components/Common/BloxButton";
import { IconButton } from "styled_components/Common/IconButton";
import LoadingCube from "sub_components/Common/LoadingCube";
import { WindowsPopUp } from "sub_components/Common/WindowsPopUp";
import { StartTour } from "styled_components/Tour/StartTour";
import FeedbackModal from "sub_components/Misc/Feedback/Feedback";
import { ClientData } from "services/clientData";
import { validateAuthState } from "actions/auth";
import { LoginPageWrapper } from "pages/Login/LoginPageWrapper";
import { FeedbackTour } from "styled_components/Common/FeedBackTour";
import { Permissions } from "services/permissions";
import { setHomeTour } from "actions/tour";
import { CompanyProfileApi } from "services/companyProfile";
import HomeWrapper from "pages/Home/HomeWrapper";
import ResizeObserver from "resize-observer-polyfill";
import PortalLayoutWrapper from "sub_components/Layout/PortalLayoutWrapper";
import { NotFound } from "pages/NotFound";
import Information from "sub_components/Misc/Information/Information";

class Portal extends Component {
  constructor(props) {
    super(props);
    this.companyApi = new CompanyProfileApi();
    this.state = {
      showLogin: true,
      breakpoint: RESOLUTIONS.MED,
      auth: false,
      windows: false,
      hasProfileAccess: false,
      hasBillingAccess: false,
      hasStorageAccess: false,
      hasSupportAccess: false,
      hasColoAccess: null,
      stepIndex: 0,
      accountPages: null,
      checkSessionInterval: null,
    };
  }
  setCheckAuthInterval = () => {
    const {
      location: { pathname },
      validateAuthState,
    } = this.props;
    const { checkSessionInterval } = this.state;
    if (
      pathname !== "/login" &&
      pathname !== "/" &&
      pathname !== "/sandbox" &&
      !pathname.match(/passwordRegistration/) &&
      checkSessionInterval === null
    ) {
      const checkSessionInterval = setInterval(
        () => validateAuthState(),
        30000
      );

      this.setState({ checkSessionInterval });
    }
  };

  componentWillUnmount() {
    const { navigate } = this.props;
    const { checkSessionInterval } = this.state;
    clearInterval(checkSessionInterval);
    navigate("/portal");
  }

  updateScreenBreakpoint = (screenWidth, screenHeight) => {
    let breakpoint = RESOLUTIONS.MED;

    if (screenWidth > RESOLUTIONS.LOW && screenWidth <= RESOLUTIONS.MED) {
      breakpoint = RESOLUTIONS.LOW;
    } else if (
      screenWidth > RESOLUTIONS.MED &&
      screenWidth <= RESOLUTIONS.HIGH
    ) {
      breakpoint = RESOLUTIONS.MED;
    } else if (screenWidth > RESOLUTIONS.HIGH) {
      breakpoint = RESOLUTIONS.HIGH;
    } else {
      breakpoint = RESOLUTIONS.MIN;
    }

    this.setState({ breakpoint, screenWidth, screenHeight });
  };
  getModulePagesAccount = async (id) => {
    const {
      auth_status: {
        user: { id: userId },
      },
      company_info: {
        customer: { id: orgId },
      },
    } = this.props;
    const response = await Permissions.getModulePermissions(id, userId, orgId);
    if (response && !response.data.error) {
      this.setState({ accountPages: { permissions: response.data.pages } });
    }
  };

  componentDidMount() {
    const {
      auth_status,
      location: { pathname },
    } = this.props;
    const { showLogin } = this.state;
    window.history.replaceState({}, null);
    this.checkWindows();
    this.getModulePagesAccount(3);
    if (pathname) {
      this.setCheckAuthInterval();
    }

    if (auth_status?.status === "LOGIN_SUCCESS" && showLogin) {
      const reveal = document.getElementById("reveal");
      if (reveal) {
        reveal.classList.add("reveal");
        setTimeout(
          function () {
            this.setState({ showLogin: false });
          }.bind(this),
          1000
        );
      }
    }
    this.screenObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const screenWidth = entry.contentRect.width;
        const screenHeight = entry.contentRect.height;
        this.updateScreenBreakpoint(screenWidth, screenHeight);
      });
    });
    const htmlEl = document.querySelector("html");
    this.screenObserver.observe(htmlEl);
  }

  checkWindows = () => {
    const isIE = ClientData.getBrowser() === "IE";

    if (isIE) {
      this.setState({ windows: true });

      setTimeout(() => {
        this.setState({ windows: false });
      }, 7000);
    }
  };
  closeWindowsModal = () => {
    this.setState({ windows: false });
  };

  openCookiePolicy = () => {
    window.open(
      "https://www.dcblox.com/cookie-policy",
      "Cookie policy",
      "noopener"
    );
  };
  closeTour = (joyride) => {
    const { setHomeTour } = this.props;
    const action = joyride?.action;
    if (action === "close" || action === "reset" || action === "stop") {
      setHomeTour({ runHomeTour: false, action: "complete" });
    }
  };
  openFeedback = () => {
    const { setHomeTour, site } = this.props;
    const feedbackId =
      site?.module === "LOGIN" || site?.module === "HOME"
        ? "feedback-image-home"
        : "feedback-image";

    setHomeTour({ runHomeTour: false, action: "complete" });
    const feedback = document.getElementById(feedbackId);
    if (feedback && feedback.length !== 0) {
      feedback.click();
    }
  };

  restartTour = () => {
    const { setHomeTour } = this.props;
    setHomeTour({ runHomeTour: true, action: "restart" });
  };

  getTourID = (site) => {
    return site?.module === "LOGIN" || site?.module === "HOME"
      ? "start-tour-container"
      : "start-tour-container-portal";
  };

  showFeedbackButton = (site, moduleOrder) => {
    return site?.module === "HOME" && moduleOrder ? false : true;
  };

  show = (action, showFB) => {
    return (action === "stop" && showFB) || (action === "close" && showFB)
      ? true
      : false;
  };

  revealScreen = (auth_status, showLogin) => {
    return auth_status?.status === "LOGIN_SUCCESS" && showLogin ? true : false;
  };

  checkAccess = (access) => {
    const props = this.props;
    return access ? (
      <PortalLayoutWrapper {...props} />
    ) : (
      <HomeWrapper {...props} />
    );
  };

  render() {
    const {
      site,
      isAuthenticated,
      hasSupportAccess,
      hasStorageAccess,
      hasBillingAccess,
      hasProfileAccess,
      hasColoAccess,
      navigate,
      auth_status,
      location,
      tour: { runHomeTour: { runHomeTour, action } } = {},
    } = this.props;
    const { showLogin } = this.state;
    const props = this.props;
    const { windows, stepIndex, accountPages, breakpoint } = this.state;
    const moduleOrder = location?.state?.moduleOrder;
    const tourId = this.getTourID(site);
    const showFB = this.showFeedbackButton(site, moduleOrder);
    const showFeedback = this.show(action, showFB);
    const hasUserManagementAccess = Permissions.checkComponentAccess(
      accountPages,
      "Account Management",
      "user-management"
    );
    const revealScreen = this.revealScreen(auth_status, showLogin);

    const user = auth_status?.user;
    const isSharedUser = user?.sharedUser === true;
    const isSupportRoute = location?.pathname?.startsWith("/portal/support");

    if (isSharedUser && !isSupportRoute) {
      navigate("/portal/support", { replace: true });
      return null;
    }

    return (
      <div className="portal">
        {windows && <WindowsPopUp onClick={this.closeWindowsModal} />}
        {!runHomeTour && (
          <CookieConsent
            location="top"
            buttonText="X"
            containerClasses="cookie-container"
            buttonWrapperClasses="cookie-button-wrapper"
            contentClasses="cookie-content body10"
            ButtonComponent={IconButton}
          >
            We use cookies to give you the best possible experience on our
            website. If you continue without changing your settings, you are
            consenting to the use of cookies on our site.
            <BloxButton
              className="buttons41"
              id="view-policy"
              text="View Policy"
              module="support"
              enabled={true}
              onClick={this.openCookiePolicy}
              cypressId="view-policy"
            />
          </CookieConsent>
        )}
        <Suspense fallback={<LoadingCube />}>
          <Routes>
            <Route path="*" element={<NotFound />} />
            <Route path="billing" element={this.checkAccess(hasBillingAccess)}>
              <Route
                path="current_invoices"
                element={this.checkAccess(hasBillingAccess)}
              >
                <Route
                  path=":invoiceId"
                  element={this.checkAccess(hasBillingAccess)}
                />
              </Route>
              <Route
                path="invoice_history"
                element={this.checkAccess(hasBillingAccess)}
              >
                <Route
                  path=":invoiceId"
                  element={this.checkAccess(hasBillingAccess)}
                />
              </Route>
              <Route
                path="make_a_payment"
                element={this.checkAccess(hasBillingAccess)}
              />
            </Route>

            <Route path="colocation" element={this.checkAccess(hasColoAccess)}>
              <Route path="rack" element={this.checkAccess(hasColoAccess)}>
                <Route
                  path=":rackId"
                  element={this.checkAccess(hasColoAccess)}
                />
              </Route>
              <Route path="power" element={this.checkAccess(hasColoAccess)} />
              <Route path="network" element={this.checkAccess(hasColoAccess)} />
              <Route
                path="environment"
                element={this.checkAccess(hasColoAccess)}
              />
            </Route>

            <Route path="account" element={this.checkAccess(hasProfileAccess)}>
              <Route
                path="documents"
                element={this.checkAccess(hasProfileAccess)}
              />
              <Route
                path="account_management"
                element={this.checkAccess(hasProfileAccess)}
              >
                <Route
                  path=":userId"
                  element={this.checkAccess(hasProfileAccess)}
                />
              </Route>
              <Route
                path="my_profile"
                element={this.checkAccess(hasProfileAccess)}
              />
              <Route
                path="notifications"
                element={this.checkAccess(hasProfileAccess)}
              />
            </Route>

            <Route
              path="support"
              element={
                hasSupportAccess ? (
                  <PortalLayoutWrapper {...props} />
                ) : (
                  <HomeWrapper {...props} />
                )
              }
            >
              <Route
                path="ticket_history"
                element={this.checkAccess(hasSupportAccess)}
              >
                <Route
                  path="service"
                  element={this.checkAccess(hasSupportAccess)}
                >
                  <Route
                    path=":id"
                    element={this.checkAccess(hasSupportAccess)}
                  />
                </Route>
                <Route
                  path="incident"
                  element={this.checkAccess(hasSupportAccess)}
                >
                  <Route
                    path=":id"
                    element={this.checkAccess(hasSupportAccess)}
                  />
                </Route>
                <Route
                  path="support"
                  element={this.checkAccess(hasSupportAccess)}
                >
                  <Route
                    path=":id"
                    element={this.checkAccess(hasSupportAccess)}
                  />
                </Route>
              </Route>
            </Route>

            <Route path="storage" element={this.checkAccess(hasStorageAccess)}>
              <Route
                path="share_detail"
                element={this.checkAccess(hasStorageAccess)}
              >
                <Route
                  path=":share"
                  element={this.checkAccess(hasStorageAccess)}
                />
              </Route>
            </Route>

            <Route
              path="/"
              element={
                <>
                  <div id="reveal" className="portal-home-page">
                    {!auth_status?.isAuthenticated || revealScreen ? (
                      <LoginPageWrapper isAuthenticated={isAuthenticated} />
                    ) : (
                      <HomeWrapper />
                    )}
                  </div>
                </>
              }
            />
          </Routes>
        </Suspense>

        <StartTour
          module={site?.module}
          restartTour={this.restartTour}
          id={tourId}
          breakpoint={breakpoint}
          stepIndex={stepIndex}
          hasBillingAccess={hasBillingAccess}
          hasProfileAccess={hasProfileAccess}
          hasStorageAccess={hasStorageAccess}
          hasSupportAccess={hasSupportAccess}
          hasUserManagementAccess={hasUserManagementAccess}
        />

        <FeedbackModal site={site} breakpoint={breakpoint} />
        <Information site={site} breakpoint={breakpoint} navigate={navigate} />
        {showFeedback && (
          <FeedbackTour
            closeTour={this.closeTour}
            setHomeTour={setHomeTour}
            openFeedback={this.openFeedback}
            site={site}
            module={site?.module}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    company_info: state.company_info,
    auth_status: state.auth_status,
    site: state.site_tracking,
    tour: state.tours,
  };
}
export default connect(mapStateToProps, { validateAuthState, setHomeTour })(
  Portal
);
